import { render } from '@mairistem/module';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import PDF_WORKER_MIN from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import React from 'react';
import ReactDOM from 'react-dom';
import AppComptabilite from './AppComptabilite';
import { initialize } from './sentry';
import '@mairistem/comptabilite/comptabilite.css';
import '@mairistem/finances-utils/finances-utils.css';
import '@mairistem/piecesjointes/piecesjointes.css';
import 'rsuite-table/dist/css/rsuite-table.min.css';

const code = '360_EXE';

GlobalWorkerOptions.workerSrc = PDF_WORKER_MIN;

// Ne pas modifier ou supprimer
// Utile en mode production afin que le style se place au bon endroit
if (process.env.NODE_ENV !== 'development') {
	const oldCreatePortal = ReactDOM.createPortal;

	ReactDOM.createPortal = (child, domNode) =>
		oldCreatePortal(
			child,
			domNode === document.body
				? document.querySelector(`#${CSS.escape(code)}`) || domNode
				: domNode || document.querySelector(`#${CSS.escape(code)}`),
		);
}

initialize();

render(<AppComptabilite />);
